import React, { ReactNode } from 'react'

export interface FilterFieldsProps {
  children: ReactNode
}

/** Контейнер с сеткой для полей фильтра */
export default function FilterFields ({ children }: FilterFieldsProps) {
  return (
    <div className="FilterPanel__Fields">
      {children}
    </div>
  )
}
